import { render } from "./MobileInput.vue?vue&type=template&id=5af71d74&ts=true"
import script from "./MobileInput.vue?vue&type=script&lang=ts"
export * from "./MobileInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__